const errorStrings = {
  1: `Please select a division`,
  2: `Please select at least one Go Rounds`,
  3: (<span>
    Please select at least:<br/>
      2 Total Long Go Rounds, or<br/>
      1 Total Long Go Rounds and<br/>
      1 Places Paid / Final to Calculate Aggregate
  </span>),
  4: (<span>
    Please select at least:<br/>
      1 Places Paid/Long Round,<br/>
      1 Places Paid/ Final, or<br/>
      1 Places Paid/ Aggregate
  </span>)
};

export const validateCalcForm = (calcParams) => {
  const errorList = [];
  if (!calcParams.division) {
    errorList.push(errorStrings[1]);
  };

  if (!calcParams.goRounds && calcParams.longRoundsPlaces) {
    errorList.push(errorStrings[2]);
  };

  // if ( calcParams.goRounds < 2 && !calcParams.finalsPlaces && calcParams.aggregatePlaces ) {
  //   errorList.push(errorStrings[3]);
  // };

  if (
    !calcParams.longRoundsPlaces && 
    !calcParams.finalsPlaces && 
    !calcParams.aggregatePlaces
  ) {
    errorList.push(errorStrings[4]);
  }
  
  return errorList;
};